import validateFieldForPlaceholder from 'lib/validateFieldPlaceholder';
import React from 'react';
/*
----------------------------------
RenderListURL Component
----------------------------------
This Component renders the list of urls
----------------------------------
*/
const RenderListURL = ({ list, listConfig, name = '' }) => {
  // if list is empty or null
  if (
    !list ||
    !Array.isArray(list) ||
    list.length === 0 ||
    Object.keys(list[0]).length === 0
  ) {
    return (
      <tr key={`list-${name}`}>
        <td>{name}</td>
        <td colSpan={2}>{validateFieldForPlaceholder(null)}</td>
      </tr>
    );
  }

  const childNode = listConfig?.childNode
    ? listConfig.childNode
    : Object.keys(list[0])[0];

  const listItems = list.map((item) => {
    return (
      <a
        key={item[childNode]}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item[childNode]}
      </a>
    );
  });

  return (
    <tr key={`list-${name}`}>
      <td>{name}</td>
      <td colSpan={2}>
        {listItems.map((item, index) => {
          return (
            <span key={index} className="mr-2">
              {item}
            </span>
          );
        })}
      </td>
    </tr>
  );
};

export default RenderListURL;
